export default __webpack_public_path__ + "static/media/logo-purple.1a1dac90.webp";